import React from 'react';
import { Link } from 'react-router-dom';
import KaminskyPic from '../images/KaminskyPic.jpeg';
import KaminskyPicShaded from '../images/KaminskyPicShade.jpg';
import LazarovPicShaded from '../images/LazarovPicShaded.jpg';
import LazarovPic from '../images/LazarovPic.jpeg';
import About from './About';

const largeDivStyle = {
  padding: "20px",
  alignContent: "center"
};

const smallerDivStyle = {
  margin: "auto",
  textAlign: "center"
};

const imgStyle = {
  padding: "20px",
  height: "20%",
  width: "40%"
};

const HomePage = () => {
  return (
    <div>
      <div style={largeDivStyle}>
        <About/>
      </div>
      <div style={smallerDivStyle}>
        <Link to="/NetaKaminsky">
          <img 
            src={KaminskyPic}
            style={imgStyle}
            onMouseOver={e => (e.currentTarget.src = KaminskyPicShaded)}
            onMouseOut={e => (e.currentTarget.src = KaminskyPic)}
            alt="kaminsky"
          />
        </Link>
        <Link to="/DrAnetaLazarov">
          <img 
            src={LazarovPic}
            style={imgStyle}
            onMouseOver={e => (e.currentTarget.src = LazarovPicShaded)}
            onMouseOut={e => (e.currentTarget.src = LazarovPic)}
            alt="lazarov"
          />
        </Link>
      </div>
    </div>
  );
};

export default HomePage;
